import { createStyles } from 'antd-style';

export const useStyle = createStyles(({ css }) => {
  return {
    layout: css`
      height: 100%;
      display: flex;
      flex-direction: column;
    `,
    chat: css`
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
      background: #fff;
    `,
    messages: css`
      flex: 1;
      overflow: auto;
      padding: 24px;
      padding-bottom: 8px;
    `,
    sender: css`
      width: 100%;
      .ant-input {
        font-size: 14px;
        padding: 4px 8px;
      }
      .ant-btn {
        padding: 4px 8px;
        height: 28px;
      }
    `,
    senderToolbar: css`
      width: 92%;
      margin: 8px auto 16px auto;
      padding: 0 24px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      align-items: center;
      justify-items: center;
      transform: scale(0.9);
    `,
    senderToolbarItem: css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      border: none;
      background: transparent;
      color: #333;
      font-size: 18px;
      margin: 0 auto;
      transition: all .2s ease;
      &:hover {
        color: #1890ff;
        background: #e6f7ff;
      }
    `,
    imagePreviewRow: css`
      padding: 0 24px;
      overflow: visible;
      will-change: transform, opacity;
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                  opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      transform-origin: top;
    `,
    imagePreview: css`
      position: relative;
      display: inline-flex;
      align-items: center;
      
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        vertical-align: middle;
        will-change: transform;
        backface-visibility: hidden;
        transform: translateZ(0);
      }
    `,
    removeImage: css`
      position: absolute;
      right: -6px;
      top: -6px;
      width: 14px;
      height: 14px;
      line-height: 12px;
      text-align: center;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.45);
      color: #fff;
      cursor: pointer;
      font-size: 10px;
      will-change: transform;
      transform: translateZ(0);
      
      &:hover {
        background: rgba(0, 0, 0, 0.65);
      }
    `,
    imageLoading: css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 0.8);
      padding: 4px;
      border-radius: 4px;
    `,
    messageContainer: css`
      display: flex;
      flex-direction: column;
      gap: 8px;
    `,
    messageText: css`
      word-break: break-word;
      white-space: pre-wrap;
    `,
    messageImage: css`
      margin-top: 8px;
      
      img {
        max-width: 200px;
        max-height: 200px;
        border-radius: 4px;
        object-fit: contain;
        will-change: transform;
        backface-visibility: hidden;
        transform: translateZ(0);
        cursor: pointer;
        
        &:hover {
          opacity: 0.9;
        }
      }
    `,
    imagePreviewModal: css`
      img {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
        will-change: transform;
        backface-visibility: hidden;
        transform: translateZ(0);
      }
    `,
  };
}); 